"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.defaultArgsGetter = defaultArgsGetter;
exports.objectOrFunc = objectOrFunc;
exports.generateUrlString = generateUrlString;
exports.getObjectFromQuery = getObjectFromQuery;
exports.createEntityFilterer = createEntityFilterer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.replace");

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _withWhereaboutsFilter = _interopRequireDefault(require("./with-whereabouts-filter"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(source).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function defaultArgsGetter(props) {
  return _objectSpread({}, props.filters.filterValues, {
    sort: props.filters.sortingValues
  });
}

function objectOrFunc(target) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return _lodash.default.isFunction(target) ? target.apply(void 0, args) : target;
}
/**
 * Generates query param values (e.g. "Test|asc", "|desc")
 * @param filterValue
 * @param sortingValue
 * @param separator
 * @returns {string}
 */


function generateUrlString() {
  var filterValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var sortingValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var separator = arguments.length > 2 ? arguments[2] : undefined;
  var sanitisedFilterValue = (filterValue || '').replace(/|/g, '');
  return sanitisedFilterValue + (sortingValue ? "".concat(separator).concat(sortingValue) : '');
}
/**
 * Transforms a whereabouts query object into a filters/sorting object.
 * @param queryObject
 * @param namespace
 * @param sortingSeparator
 * @param urlSeparator
 * @returns {{filters, sorting}}
 */


function getObjectFromQuery(queryObject, namespace, sortingSeparator, urlSeparator) {
  var final = {
    filters: _lodash.default.chain(queryObject).pickBy(function (v, k) {
      return k.includes(namespace);
    }).mapValues(function (v) {
      return v.split(sortingSeparator)[0];
    }).mapKeys(function (v, k) {
      return k.split(urlSeparator)[1];
    }).pickBy(Boolean).value(),
    sorting: _lodash.default.chain(queryObject).pickBy(function (v, k) {
      return k.includes(namespace);
    }).mapValues(function (v) {
      return v.split(sortingSeparator)[1];
    }).mapKeys(function (v, k) {
      return k.split(urlSeparator)[1];
    }).pickBy(Boolean).value()
  };
  return final;
}
/**
 * Create an entity filterer to be used in your app.
 * @param entityHoC The entity HoC to use (withEntityList, withQuery, etc.)
 * @param argsGetter Function to transform props into args to be consumed by model generator
 * @returns {withFilteredEntity}
 */


function createEntityFilterer(entityHoC, argsGetter) {
  return function withFilteredEntity(queryOrModel, filterConfig) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var isQuery = !!queryOrModel.model;
    var finalEntityHoc;

    if (isQuery) {
      var existingArgs = queryOrModel.args;

      queryOrModel.args = function (props) {
        return _objectSpread({}, props.args, {}, objectOrFunc(existingArgs, props), {}, (argsGetter || defaultArgsGetter)(props));
      };

      finalEntityHoc = entityHoC(queryOrModel);
    } else {
      finalEntityHoc = entityHoC(queryOrModel, _objectSpread({
        args: function args(props) {
          return _objectSpread({}, props.args, {}, (argsGetter || defaultArgsGetter)(props));
        }
      }, options));
    }

    return _lodash.default.flowRight((0, _withWhereaboutsFilter.default)(filterConfig, options.namespace, {}), finalEntityHoc);
  };
}